"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgSimulators = function SvgSimulators(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.015 8.534h1.488m2.053 0h2.088a1 1 0 0 1 .703.29l.532.526a1 1 0 0 0 1.425-.019l.47-.49a1 1 0 0 1 .721-.307h1.065a1 1 0 0 1 .696.282l.564.547a1 1 0 0 0 1.419-.027l.47-.493a1 1 0 0 1 .723-.309h2.098m2.05 0h1.383",
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#4A4A4A",
    x: 1.5,
    y: 0.5,
    width: 2,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#4A4A4A",
    x: 1.5,
    y: 13.5,
    width: 2,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#4A4A4A",
    x: 16.5,
    y: 0.5,
    width: 2,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#4A4A4A",
    x: 16.5,
    y: 13.5,
    width: 2,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#4A4A4A",
    x: 1.5,
    y: 6.5,
    width: 2,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#4A4A4A",
    x: 16.5,
    y: 6.5,
    width: 2,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#4A4A4A",
    x: 5.5,
    y: 12.5,
    width: 9,
    height: 6,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.474 15v3m3.043-3v3M0 15.5h1.51m1.989 0h2.462m9.024 0h1.547m1.983 0h1.47M0 2.5h1.516m2.005 0h12.982m2.044 0H20",
    stroke: "#4D4D4D"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgSimulators);
var _default = exports["default"] = Memo;